var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2406 2.61204C15.1752 0.0137994 17.8643 0 17.8643 0C17.8643 0 18.2643 2.44299 16.3428 4.7958C14.2911 7.30927 11.9585 6.89726 11.9585 6.89726C11.9585 6.89726 11.5208 4.92197 13.2406 2.61204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2058 8.60957C13.2011 8.60957 15.0477 7.21533 17.4519 7.21533C21.59 7.21533 23.2179 10.2162 23.2179 10.2162C23.2179 10.2162 20.0341 11.8746 20.0341 15.9001C20.0341 20.4406 24 22.0054 24 22.0054C24 22.0054 21.2268 29.9578 17.4819 29.9578C15.7616 29.9578 14.4243 28.775 12.6121 28.775C10.765 28.775 8.93199 30.0002 7.73835 30.0002C4.31848 30.0002 0 22.4568 0 16.393C0 10.4296 3.65734 7.29764 7.08736 7.29764C9.31504 7.29912 11.045 8.60957 12.2058 8.60957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.2f33637de0fa17b4a399bb7878a82d57.svg";
export { ForwardRef as ReactComponent };